/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleIntegrationUsagePeriodData } from './GoogleIntegrationUsagePeriodData';
import {
    GoogleIntegrationUsagePeriodDataFromJSON,
    GoogleIntegrationUsagePeriodDataFromJSONTyped,
    GoogleIntegrationUsagePeriodDataToJSON,
    GoogleIntegrationUsagePeriodDataToJSONTyped,
} from './GoogleIntegrationUsagePeriodData';

/**
 * 
 * @export
 * @interface GoogleIntegrationUsageData
 */
export interface GoogleIntegrationUsageData {
    /**
     * 
     * @type {GoogleIntegrationUsagePeriodData}
     * @memberof GoogleIntegrationUsageData
     */
    today?: GoogleIntegrationUsagePeriodData;
    /**
     * 
     * @type {GoogleIntegrationUsagePeriodData}
     * @memberof GoogleIntegrationUsageData
     */
    currentMonth?: GoogleIntegrationUsagePeriodData;
    /**
     * 
     * @type {GoogleIntegrationUsagePeriodData}
     * @memberof GoogleIntegrationUsageData
     */
    previousMonth?: GoogleIntegrationUsagePeriodData;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsageData
     */
    dailyBytesLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleIntegrationUsageData
     */
    monthlyBytesLimit?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleIntegrationUsageData
     */
    dailyLimitExhausted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleIntegrationUsageData
     */
    monthlyLimitExhausted?: boolean;
}

/**
 * Check if a given object implements the GoogleIntegrationUsageData interface.
 */
export function instanceOfGoogleIntegrationUsageData(value: object): value is GoogleIntegrationUsageData {
    return true;
}

export function GoogleIntegrationUsageDataFromJSON(json: any): GoogleIntegrationUsageData {
    return GoogleIntegrationUsageDataFromJSONTyped(json, false);
}

export function GoogleIntegrationUsageDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleIntegrationUsageData {
    if (json == null) {
        return json;
    }
    return {
        
        'today': json['today'] == null ? undefined : GoogleIntegrationUsagePeriodDataFromJSON(json['today']),
        'currentMonth': json['currentMonth'] == null ? undefined : GoogleIntegrationUsagePeriodDataFromJSON(json['currentMonth']),
        'previousMonth': json['previousMonth'] == null ? undefined : GoogleIntegrationUsagePeriodDataFromJSON(json['previousMonth']),
        'dailyBytesLimit': json['dailyBytesLimit'] === undefined ? undefined : json['dailyBytesLimit'] === null ? null : json['dailyBytesLimit'],
        'monthlyBytesLimit': json['monthlyBytesLimit'] === undefined ? undefined : json['monthlyBytesLimit'] === null ? null : json['monthlyBytesLimit'],
        'dailyLimitExhausted': json['dailyLimitExhausted'] == null ? undefined : json['dailyLimitExhausted'],
        'monthlyLimitExhausted': json['monthlyLimitExhausted'] == null ? undefined : json['monthlyLimitExhausted'],
    };
}

export function GoogleIntegrationUsageDataToJSON(json: any): GoogleIntegrationUsageData {
    return GoogleIntegrationUsageDataToJSONTyped(json, false);
}

export function GoogleIntegrationUsageDataToJSONTyped(value?: GoogleIntegrationUsageData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'today': GoogleIntegrationUsagePeriodDataToJSON(value['today']),
        'currentMonth': GoogleIntegrationUsagePeriodDataToJSON(value['currentMonth']),
        'previousMonth': GoogleIntegrationUsagePeriodDataToJSON(value['previousMonth']),
        'dailyBytesLimit': value['dailyBytesLimit'],
        'monthlyBytesLimit': value['monthlyBytesLimit'],
        'dailyLimitExhausted': value['dailyLimitExhausted'],
        'monthlyLimitExhausted': value['monthlyLimitExhausted'],
    };
}

